module.exports = __webpack_public_path__ + "media/images/mobile/abouts/c_bg-fdfc3d326e95cca848cedae24867621a.jpg";